/* unplugin-vue-components disabled */import { render } from "./draw.vue?vue&type=template&id=515376a6&scoped=true"
import script from "./draw.vue?vue&type=script&lang=js"
export * from "./draw.vue?vue&type=script&lang=js"

import "./draw.vue?vue&type=style&index=0&id=515376a6&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515376a6"]])

export default __exports__